const Historia = (props) => {
  const { contenido, titulo, ciudad, departamento } = props;
  return (
    <div className="w-10/12 h-full mx-auto lg:w-7/12">
      <div className="my-5 lg:hidden">
        <p className="poppins-700 pb-3 lg:invisible ">{titulo} </p>
        <hr />
        <p className="poppins-300 alineado-verticalmente pt-3 lg:invisible " ><span className="icon-ubicacion mr-3 md:invisible "></span> {ciudad}, {departamento} </p>
      </div>

      <div className="lg:pt-40">
        {contenido()}
      </div>
      
      <img className="w-20 mx-auto py-16 xl:py-20" src={require(`../../images/iconos-historia/pintura.svg`).default} alt="paleta de pintura" />

    </div>
  )
}
export default Historia;